//TODO this is a security issue
import pkg from '../package.json'
import ReactDOM from 'react-dom'
import './index.css'
import './services/axios'
import App from './App'
import reportWebVitals from './reportWebVitals'
import theme from '@utils/theme'
import { CssBaseline, ThemeProvider } from '@material-ui/core'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { persistor, store } from './state/store'
import { SiteContextProvider } from '@contexts/SiteContext'
import { MemberContextProvider } from './contexts'
import { SnackbarProvider } from 'notistack'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

ReactDOM.render(
  <Provider store={store}>
    <SnackbarProvider>
      <MemberContextProvider>
        <SiteContextProvider>
          <PersistGate loading={null} persistor={persistor}>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <App />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </PersistGate>
        </SiteContextProvider>
      </MemberContextProvider>
    </SnackbarProvider>
  </Provider>,
  document.getElementById('root'),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
